var map = {
	"./cards-effect.json": 1333,
	"./connect-fb-popup.json": 1334,
	"./crop-icon-package-1.json": 1335,
	"./crop-icon-package-10.json": 1336,
	"./crop-icon-package-11.json": 1337,
	"./crop-icon-package-12.json": 1338,
	"./crop-icon-package-13.json": 1339,
	"./crop-icon-package-14.json": 1340,
	"./crop-icon-package-15.json": 1341,
	"./crop-icon-package-16.json": 1342,
	"./crop-icon-package-17.json": 1343,
	"./crop-icon-package-18.json": 1344,
	"./crop-icon-package-19.json": 1345,
	"./crop-icon-package-2.json": 1346,
	"./crop-icon-package-20.json": 1347,
	"./crop-icon-package-3.json": 1348,
	"./crop-icon-package-4.json": 1349,
	"./crop-icon-package-5.json": 1350,
	"./crop-icon-package-6.json": 1351,
	"./crop-icon-package-7.json": 1352,
	"./crop-icon-package-8.json": 1353,
	"./crop-icon-package-9.json": 1354,
	"./dailylogin.json": 1355,
	"./easter.json": 1356,
	"./event_quests.json": 1357,
	"./gold_card_animation.json": 1358,
	"./ice_card_animation.json": 1359,
	"./loadingscreen.json": 1360,
	"./lucky_wheel.json": 1361,
	"./luckyturnips.json": 1362,
	"./map-package-1.json": 1363,
	"./map-package-10.json": 1364,
	"./map-package-11.json": 1365,
	"./map-package-12.json": 1366,
	"./map-package-13.json": 1367,
	"./map-package-14.json": 1368,
	"./map-package-15.json": 1369,
	"./map-package-16.json": 1370,
	"./map-package-17.json": 1371,
	"./map-package-18.json": 1372,
	"./map-package-19.json": 1373,
	"./map-package-2.json": 1374,
	"./map-package-20.json": 1375,
	"./map-package-3.json": 1376,
	"./map-package-4.json": 1377,
	"./map-package-5.json": 1378,
	"./map-package-6.json": 1379,
	"./map-package-7.json": 1380,
	"./map-package-8.json": 1381,
	"./map-package-9.json": 1382,
	"./my-pet-minigame.json": 1383,
	"./my_farm.json": 1384,
	"./package_1.json": 1385,
	"./package_2.json": 1386,
	"./payer_reactivation_offer.json": 1387,
	"./pets.json": 1388,
	"./quests.json": 1389,
	"./reward.json": 1390,
	"./rope_card_animation.json": 1391,
	"./savestate_select_popup.json": 1392,
	"./starchests.json": 1393,
	"./sunday_offer_v2.json": 1394,
	"./wheel.json": 1395,
	"./world1.json": 1396,
	"./world10.json": 1397,
	"./world10@0.5x.json": 1398,
	"./world11.json": 1399,
	"./world11@0.5x.json": 1400,
	"./world12.json": 1401,
	"./world12@0.5x.json": 1402,
	"./world13.json": 1403,
	"./world13@0.5x.json": 1404,
	"./world14.json": 1405,
	"./world14@0.5x.json": 1406,
	"./world15.json": 1407,
	"./world15@0.5x.json": 1408,
	"./world16.json": 1409,
	"./world16@0.5x.json": 1410,
	"./world17.json": 1411,
	"./world17@0.5x.json": 1412,
	"./world18.json": 1413,
	"./world18@0.5x.json": 1414,
	"./world19.json": 1415,
	"./world19@0.5x.json": 1416,
	"./world1@0.5x.json": 1417,
	"./world2.json": 1418,
	"./world20.json": 1419,
	"./world20@0.5x.json": 1420,
	"./world2@0.5x.json": 1421,
	"./world3.json": 1422,
	"./world3@0.5x.json": 1423,
	"./world4.json": 1424,
	"./world4@0.5x.json": 1425,
	"./world5.json": 1426,
	"./world5@0.5x.json": 1427,
	"./world6.json": 1428,
	"./world6@0.5x.json": 1429,
	"./world7.json": 1430,
	"./world7@0.5x.json": 1431,
	"./world8.json": 1432,
	"./world8@0.5x.json": 1433,
	"./world9.json": 1434,
	"./world9@0.5x.json": 1435,
	"./xmas_2021.json": 1436
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1332;